// Copyright 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
import { EventView } from "~/generated/graphql";
import { DetailData } from "~/components/Details/Detail";

export const DetailsFirstPreset: (
  event?: Partial<EventView>
) => DetailData[] = (event) => [
  {
    label: "Event ID",
    value: event?.id,
  },
  {
    label: "Description",
    value: event?.description || event?.plan?.description,
  },
];
